import type { ICellRendererParams } from 'ag-grid-community';
import { CustomCellEditorProps } from 'ag-grid-react';
import { ClientSelector } from 'components/secondaryMarket/shared/components/clientSelectors';
import { ISalesCounterpart } from 'models/ISalesCounterpart';
import { FC } from 'react';
import { htmlDecode } from 'utils/html-decode';

export const ClientCellEditor = ({ onValueChange, value }: CustomCellEditorProps<unknown, ISalesCounterpart>) => {
  return (
    <ClientSelector
      onClientChanged={client => {
        onValueChange(client ?? null);
      }}
      autoOpen={true}
      selectedClient={value ?? undefined}
      loadingStatus="success"
      onClientClear={() => {
        onValueChange(null);
      }}
      getErrors={() => {
        return [];
      }}
    />
  );
};

export const ClientCellRenderer: FC<ICellRendererParams<unknown, ISalesCounterpart>> = ({ value }) => {
  if (!value) {
    return null;
  }
  const clientDisplay = htmlDecode(`${value.label} (${value.id} - ${value.eliotCode})`);
  return <span>{clientDisplay}</span>;
};
